<template>
  <div>
    <van-nav-bar placeholder title="课程选择" >
      <template #right>
      </template>
    </van-nav-bar>
    <!--搜索-->
    <div class="top-search clearfiex">
      <van-search
          v-model="queryParams.name"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
      >
        <template #action>
          <button @click="onSearch" class="search-but">搜索</button>
        </template>
      </van-search>
    </div>

    <!-- tab -->
    <div class="c-class">
      <van-tabs v-model="queryParams.institutionId" title-active-color="#ffffff" :border="false" @change="tabChange">
        <!--<van-tab title="全部" name="" v-if="venueClassOptions.length > 0"/>-->
        <van-tab v-for="(item, index) in organizeList" :title="item.name" :name="item.id" :key="index"></van-tab>
      </van-tabs>
    </div>

    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
          class="jg-list"
        v-model="data.bottomLoading"
        :finished="!data.hasMore"
        finished-text="没有更多了"
        @load="bottomRefresh()"
    >
        <div class="jg-box" v-for="(e,i) in data.records" :key="i">
          <div class="jg-list-top">
            <img v-if="e.pic" :src="fileDisplayPrefix +  (e.pic || '').split(',')[0]"/>
            <img v-else src="@/assets/patternless.png">
            <div class="jg-right">
              <h2><a href="#">{{ e.name }}</a></h2>
              <span class="time">时间：{{ e.classTime }}</span>
              <span>人数：{{ e.realCount }}/{{ e.planCount }}</span>
              <span>开班日期：{{ e.startDate }}</span>
            </div>
          </div>
          <div class="jg-bottom">
            <b><i>￥</i>{{ e.price }}</b>
            <van-button type="info" class="jg-but" @click="getDetailUrl(e)">报名</van-button>
          </div>
        </div>
    </van-list>
    </van-pull-refresh>

  </div>
</template>

<script>

import {handlePageData} from '@/utils/common'
import {getCurriculumList, getOrganize} from "../../api/courseSelection/courseSelection";
import {FILE_DISPLAY_PREFIX} from "../../api/upload";
import {myMixins} from "@/utils/loginMixins";

export default {
  // mixins: [myMixins],
  name: 'Index',
  components: {},
  data() {
    return {
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      page:'',
      queryParams: {},
      fileDisplayPrefix:FILE_DISPLAY_PREFIX,
      curriculumList: [],
      organizeList: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      getOrganize().then(res => {
        if (res.code === 10000) {
          if (res.result.length > 0){
            this.organizeList = res.result
          }
          this.reset()
          this.getList()
        }
      })
    },

    getDetailUrl(e){
      if (e.realCount < e.planCount){

        this.$router.push({path: `/courseSelection/courseDetail?id=${e.id}`})
      }else {
        this.$toast("人员已满！");
      }
    },
    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    tabChange() {
      this.$nextTick(() => {
        this.data.records = []
        this.refresh()
      })
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },

    onSearch() {
      if (this.data.current === this.page ){
        this.refresh()
      }
    },
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size

      if (!this.queryParams.institutionId) {
        this.queryParams.institutionId = (this.organizeList[0] || {}).value
      }
      getCurriculumList(this.queryParams).then(res => {
        if (res.code === 10000) {
          this.page = res.result.pages
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    }
  }
}
</script>

<style scoped>
.jg-box{
  background: #ffffff;
  border-radius: 12px !important;
}
.jg-list{
  background: #f2f6fd;
}
.top-search{
  display: flex;
  height:103px;
  background: url("~@/assets/itop.png") left center;
  background-size: 100% 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
}
/deep/.van-tabs--line .van-tabs__wrap{
  background: #f2f6fd;
}
/*.top-search::after{
  display: flex;
  width: 100%;
  height:28px;
  background: #FFFFFF;
  border-radius:25px 25px 0  0;
}*/
.c-class{
  height:35px;
  border-radius:25px 25px 0  0;
  background: #f2f6fd;
  position: relative;
  top: -25px;
}
/deep/.van-tabs__nav{
  background:none;
  display: flex;
  align-items: center;
}
/deep/.van-search{
  display: flex;
  width: 100%;
  padding: 0 10px;
  background: none;
  justify-content: space-between;
  position: relative;
  top: -12px;
}
/deep/.van-search__content{
  height:28px;
  background: rgba(249,248,248,0.7);
  border-radius:100px;
  display: flex;
  justify-content: space-between;
}
/deep/.van-search .van-cell{
  padding: 0;
  display: flex;
  align-items: center;
}
/deep/.van-cell{
}
.search-but {
  display: flex;
  padding:0 3px;
  background: url("~@/assets/button-style.png") 3px 3px no-repeat #66C779;
  background-size: 11px 15px;
  border-radius: 25px;
  width:56px;
  height:28px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size:12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}
/deep/.van-search__action{
  margin:0;
  padding: 0;
  margin-left:5px;
}
/deep/.van-tabs__line{
  position: absolute;
  bottom: 15px;
  left: 0;
  z-index: 1;
  height:0;
  background-color:none;
  border-radius:0;
  display: none;
}
/deep/.van-tabs__nav--line{
  padding: 0 5px 0 5px;
}
/deep/.van-tab{
  padding: 0 10px;
  height:26px;
  background: #ffffff;
  border-radius:100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9FA0A2;
  margin: 0 5px;
}
/deep/.van-tab--active{
  background: #67C86F;
}
/deep/.van-tabs--line .van-tabs__wrap{
  height: 60px;
}
.jg-but{
  background: #66C779;
}
</style>
